var DB_VideoPlayer = {
    init:function(){
        document.querySelectorAll(".video-player").forEach(function(video_player){
            video_player.addEventListener("click", function(){
                if(video_player.classList.contains("playing")){
                    DB_VideoPlayer.pause_video(video_player);
                }else{
                    DB_VideoPlayer.play_video(video_player);
                }
            });
        })
    },
    play_video:function(video_player){
        console.log("PLAY VIDEO");
        video_player.querySelector("video").play();
        video_player.classList.add("playing");

    },
    pause_video:function(video_player){
        console.log("PAUSE VIDEO");
        video_player.querySelector("video").pause();
        video_player.classList.remove("playing");
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".video-player").length > 0){
        DB_VideoPlayer.init();
    }
})